<template>
  <div class="detail-tips">
    <div class="cate-list">
      <div class="cate-item" v-for="cate in detail.cate_tips">
        <h2>{{ cate.cate_name }}</h2>
        <div class="tips-list">
          <div class="tips-item" v-for="tip in cate.tips">
            <div class="tips-image">
              <img :src="tip.image" alt="" loading="lazy">
            </div>
            <div class="tips-container">
              <div class="tips-title">
                <p>Model</p>
                <h3>{{ tip.name }}</h3>
              </div>
              <div class="tips-content">
                <p class="ellipsis-6" v-html="tip.content"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "detail-tips",
  props: {
    detail: {
      type: Object,
      default: {}
    }
  },
  data(){
    return {

    }
  },
  mounted() {
  },
  methods: {

  }
}
</script>

<style scoped>
.detail-tips{
  width: 1400px;
  min-height: 60px;
  font-size: 20px;
  display: flex;
  padding: 0 260px;
  justify-content: space-between;
  align-items: center;
}

.detail-tips .cate-list {
  padding-bottom: 100px;
}
.detail-tips .cate-list .cate-item {}
.detail-tips .cate-list .cate-item h2 {
  font-size: 30px;
  font-weight: 500;
  margin-top: 107px;
  margin-bottom: 91px;
}
.detail-tips .cate-list .cate-item .tips-image {
  width: 670px;
  height: 270px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border-radius: 8px;
  overflow: hidden;
}
.detail-tips .cate-list .cate-item .tips-image img {
  width: 100%;
}
.detail-tips .cate-list .cate-item .tips-container {
  width: 668px;
  margin-left: 62px;
}
.detail-tips .cate-list .cate-item .tips-container .tips-title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #B5B5B5;
  padding: 16px 0 25px 35px;
}
.detail-tips .cate-list .cate-item .tips-container .tips-title p {
  color: #7D7D7D;
  font-size: 16px;
  margin-right: 57px;
}
.detail-tips .cate-list .cate-item .tips-container .tips-title h3 {
  color: #1C1B1B;
  font-size: 24px;
  font-weight: 500;
}

.detail-tips .cate-list .cate-item .tips-container .tips-content {
  padding: 31px 31px 0 32px;
  color: #7D7D7D ;
  font-size: 14px;
  line-height: 30px;
}
.ellipsis-6 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  max-height: calc(1.5em * 6);
  font-size: 14px!important;
  white-space: pre-wrap;
}


.detail-tips .cate-list .cate-item .tips-list .tips-item {
  display: flex;
  margin-bottom: 60px;
}
</style>

<style>
.detail-tips .cate-list .cate-item .tips-container .tips-content p {
  font-size: 14px!important;
}
</style>
